import React from 'react';

import { SVGComponentProps } from './svg.types';

const EyeHideSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 3C4.00699 3 1.40017 4.75778 0 7.36369C1.40017 9.97008 4.00699 11.7274 7 11.7274C9.99301 11.7274 12.5998 9.97008 14 7.36369C12.5998 4.75778 9.99301 3 7 3ZM7 10.091C5.38894 10.091 4.08328 8.87013 4.08328 7.36369C4.08328 5.85724 5.38894 4.63636 7 4.63636C8.61106 4.63636 9.91672 5.85724 9.91672 7.36369C9.91672 8.87013 8.61106 10.091 7 10.091Z"
          fill="#878A92"
        />
        <path
          d="M7 9.00014C7.9665 9.00014 8.75 8.26752 8.75 7.36378C8.75 6.46004 7.9665 5.72742 7 5.72742C6.0335 5.72742 5.25 6.46004 5.25 7.36378C5.25 8.26752 6.0335 9.00014 7 9.00014Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default EyeHideSVG;
